import { ChangeLogColumn } from './../@core/interfaces/polly-atlas.interface';
import { DropDownInterface } from 'polly-commons';
import { MenuItem } from '../../../@core/interfaces';
import { AtlasCollaboratorsTableColumnSchema, AtlasConditionalFilterOptions, AtlasExplorePayload, AtlasFilterPayload, AtlasFilteredData } from '../@core/interfaces';
import { CheckBoxOption } from 'polly-qubit';

export const CODE_EDITOR_OPTIONS = {
  lineNumbers: true, mode:'text/x-pgsql',
  gutters: ['CodeMirror-linenumbers'],
  placeholder: 'Write your SQL query here'
};

export enum SplitEventType {
  VALUE = 'value',
  CONDITION = 'condition'
}

export enum DataNature {
  NUMERIC = 'numeric',
  CHARACTER = 'character',
  BOOLEAN = 'boolean',
  JSON = 'json',
  MONETARY = 'monetary',
  DATETIME = 'date/time'
}

export type ColumnDataType = NumericType | TextualType | BooleanType | DateTimeType | JsonType | MonetaryType;

export type NumericType = 'serial' | 'bigserial' |'smallint' | 'integer' | 'bigint' | 'decimal' | 'numeric' |'real' | 'double precision';
export type TextualType = 'char' | 'varchar' | 'text';
export type BooleanType = 'boolean';
export type DateTimeType = 'date' | 'time' | 'timestamp' | 'timestampz' | 'interval';
export type JsonType = 'json';
export type MonetaryType = 'monetary';

export enum ConditionalFilterOptions {
  GREATER_THAN = 'gt',
  GREATER_THAN_EQUAL = 'gte',
  LESS_THAN = 'lt',
  LESS_THAN_EQUAL = 'lte',
  BETWEEN = 'between',
  NOT_BETWEEN = 'not_between',
  EQUALS_TO = 'eq',
  NOT_EQUALS_TO = 'ne',
  IN = 'in',
  NOT_IN = 'not_in',
  STARTS_WITH = 'startswith',
  NOT_STARTS_WITH = 'not_startswith',
  ENDS_WITH = 'endswith',
  NOT_ENDS_WITH = 'not_endswith',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'not_contains',
  IS_NULL = 'is_null'
}

export const POLLY_ATLAS_CONDITIONAL_FILTERS: AtlasConditionalFilterOptions[] = [
  { label: 'Greater than', value: ConditionalFilterOptions.GREATER_THAN },
  { label: 'Lesser than', value: ConditionalFilterOptions.LESS_THAN },
  { label: 'Between range', value: ConditionalFilterOptions.BETWEEN },
  { label: 'Equals to', value: ConditionalFilterOptions.EQUALS_TO }
];

export const DEFAULT_ATLAS_FILTER_PAYLOAD: AtlasFilterPayload = {
  data: {
    type: 'filter_options',
    attributes: {
      column_filters: [],
      sort_by: '',
      sort_order: 'asc'
    }
  }
};

export const DEFAULT_ATLAS_EXPLORE_PAYLOAD: AtlasExplorePayload = {
  data: {
    type: 'explore',
    attributes: {
      columns_selected: [],
      column_filters: [],
      sort_by: '',
      sort_order: 'asc'
    }
  }
};

export const ATLAS_FILTERED_VALUES: AtlasFilteredData = {
  filterStatus: {
    column_filters: [],
    sort_by: '',
    sort_order: 'asc'
  }
};

export enum PollyAtlasAction {
  CHANGELOG = 'changelog',
  EDIT  = 'edit',
  MANAGE = 'manage',
  ARCHIVE = 'archive'
}

export const POLLY_ATLAS_MENU_ITEMS: MenuItem[] = [
  {
    action: PollyAtlasAction.CHANGELOG,
    icon: 'polly-icon history',
    name: 'Changelog'
  },
  {
    action: PollyAtlasAction.EDIT,
    icon: 'polly-icon edit',
    name: 'Edit Atlas'
  },
  {
    action: PollyAtlasAction.MANAGE,
    icon: 'polly-icon admin',
    name: 'Manage Users'
  },
  {
    action: PollyAtlasAction.ARCHIVE,
    icon: 'polly-icon archive',
    name: 'Archive'
  }
];

export const COLLABORATORS_TABLE_COLUMNS: AtlasCollaboratorsTableColumnSchema[] = [
  {
    header: 'User Name',
    field: 'user_name',
    width: 20.1875,
  },
  {
    header: 'Role',
    field: 'access',
    width: 10
  },
  {
    header: 'Actions',
    field: 'actions',
    width: 6
  }
];

export enum PollyAtlasRoles {
  MANAGER = 'manager',
  RESEARCHER = 'researcher',
  CONTRIBUTOR = 'contributor',
  CONSUMER = 'consumer'
}

export const ACCESS_RIGHTS: DropDownInterface[] = [
  {
    label: 'Manager',
    value: PollyAtlasRoles.MANAGER
  },
  {
    label: 'Researcher',
    value: PollyAtlasRoles.RESEARCHER
  },
  {
    label: 'Contributor',
    value: PollyAtlasRoles.CONTRIBUTOR
  },
  {
    label: 'Consumer',
    value: PollyAtlasRoles.CONSUMER
  }
];

export const ATLAS_CHANGELOG_COLUMNS: ChangeLogColumn[] = [
  {
    field: 'full_name',
    width: 11.25
  },
  {
    field: 'operation',
    width: 10.625
  },
  {
    field: 'description',
    width: 17.3125
  },
  {
    field: 'time',
    width: 5
  }
];

export enum ChangelogFilterOption {
  SCHEMA = 'schema_change',
  DATA = 'data_change',
  ACCESS = 'access_change'
}

export const CHANGELOG_FILTERS: CheckBoxOption[] = [
  {
    label: 'Schema Change',
    value: ChangelogFilterOption.SCHEMA,
    checked: false
  },
  {
    label: 'Data Change',
    value: ChangelogFilterOption.DATA,
    checked: false
  },
  {
    label: 'Access Change',
    value: ChangelogFilterOption.ACCESS,
    checked: false
  }
];

export const TABLE_PAGINATOR_SIZE: number = 25;

export const TIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: true };
